import { Bookinghub } from '../../index';
import { logger } from '@tuic/logger';
import { OfferResponse, PostOfferResponse } from '../../generated/bookinghub';

/**
 * Get a custom offer for a specific user
 */
export const getOffer = async (
  email: string,
  webCode: string,
): Promise<PostOfferResponse | undefined> => {
  let response = await Bookinghub.postOffer({
    body: {
      webCode: webCode,
      email: email,
    },
  });

  if (!response.error) {
    return response.data;
  }

  logger.error(
    `[Bookinghub]: Failed to get (post) offer for user ${email} with webCode ${webCode}`,
  );
  logger.error(response.error);

  return undefined;
};

export type BookinghubOffer = OfferResponse;
